import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import SubcategoryEditDialogHeader from './SubcategoryViewDialogHeader';
import api from '@/utils/apiClient';
import { SubcategoryViewBasicDetails } from './SubcategoryViewBasicDetails';
import { SubcategoryViewTabs } from './SubcategoryViewTabs';
import LoadingIcon from 'mdi-react/LoadingIcon';

const SubcategoryViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: 'View Subcategory',
    hide: onHide,
  });

  const [state, setState] = React.useState({
    loading: false,
    subcategory: {},
    error: '',
  });

  React.useEffect(() => {
    if (id) getSubcategoryById(+id);
  }, [id]);

  const getSubcategoryById = async (subcategoryId) => {
    try {
      setState({ ...state, loading: true });
      const { data: res, isSuccess } = await api.subCategory.getSubCategoryById(subcategoryId);
      if (isSuccess) {
        setState({ ...state, loading: false, subcategory: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting subcategory details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, subcategory: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, subcategory } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <SubcategoryEditDialogHeader modal={modal} subcategory={subcategory} />
      {/*Subcategory Modal Body*/}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting subcategory details...' : error}
            </div>
          </>
        ) : (
          <>
            <SubcategoryViewBasicDetails subcategory={subcategory} />
            <SubcategoryViewTabs subcategory={subcategory} />
          </>
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(SubcategoryViewDialog);
